import React from 'react';
import styled from 'styled-components';
import I10n from '../features/i10n';
import MsxIcons from '../features/msx-icons';
import { PRIMARY_COLOR } from '../color-constants';

const DescriptionWrapper = styled.div`
  position: relative;
  display: flex;
  margin-top: 10px;
  align-items: flex-start;
`;

const Description = styled.span`
  font-size: 16px;
  color: #000000;
  font-weight: 400;
  white-space: pre-wrap;

  ${props => props.$showEllipsis && !props.$isOpen ? `
    -webkit-line-clamp: 1;
    overflow: hidden;
    -webkit-box-orient: vertical;
    display: -webkit-box;
  ` : ''}
`;

const HiddenDescription = styled.div`
  position: absolute;
  visibility: hidden;
  top: 0px;
  left: 0px;
  max-width: 100%;
  white-space: pre-wrap;
`;

const HiddenSingleLineDescription = styled.div`
  position: absolute;
  visibility: hidden;
  top: 0px;
  left: 0px;
  max-width: 100%;
  white-space: pre-wrap;

  -webkit-line-clamp: 1;
  overflow: hidden;
  -webkit-box-orient: vertical;
  display: -webkit-box;
`;

const KnowMoreWrapper = styled.div`
    display: flex;
    color: ${PRIMARY_COLOR};
    color: var(--se-secondary, ${PRIMARY_COLOR});
    white-space: nowrap;
    cursor: pointer;
`;

const KnowMoreText = styled.span`
  margin-right: 5px;
`;

const KnowMoreIcon = styled.div`
  height: 19px;
  transform: ${props => props.$isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  transition: all 0.3s;
`;

class MultiLineText extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      textLoaded: false,
      showEllipsis: false,
      isOpen: false
    };
    this._isMounted = false;
  }

  componentDidMount = () => {
    this._isMounted = true;

    this._ellipsisChecker = setInterval(() => {
      let showEllipsis = false;

      if (this._hiddenDescription && this._hiddenSingleLineDescription) {
        const hiddenRect = this._hiddenDescription.getBoundingClientRect();
        const hiddenSingleLineRect = this._hiddenSingleLineDescription.getBoundingClientRect();
        if (hiddenRect.height !== hiddenSingleLineRect.height) {
          showEllipsis = true;
        }
      }

      if (this.state.showEllipsis !== showEllipsis || this.state.textLoaded === false) {
        this.updateStateIfMounted({showEllipsis, textLoaded: true});
      }

    }, 100);
  }

  componentWillUnmount = () => {
    if (this._ellipsisChecker) {
      clearInterval(this._ellipsisChecker);
    }
    this._isMounted = false;
  }

  updateStateIfMounted = (newState) => {
    if (this._isMounted) {
      this.setState(newState);
    }
  }

  render() {
    return <DescriptionWrapper>
      <HiddenDescription ref={element => {this._hiddenDescription = element;}}>
        {this.props.text}
      </HiddenDescription>
      <HiddenSingleLineDescription ref={element => {this._hiddenSingleLineDescription = element;}}>
        {this.props.text}
      </HiddenSingleLineDescription>
      {<Description $showEllipsis={this.state.showEllipsis || !this.state.textLoaded} $isOpen={this.state.isOpen}>
        {this.props.text}
      </Description>}
      {this.state.showEllipsis && <KnowMoreWrapper onClick={() => { this.updateStateIfMounted({isOpen: !this.state.isOpen});}}>
        <KnowMoreText>{I10n.get(this.state.isOpen ? 'app.action.view_less' : 'app.action.view_more')}</KnowMoreText>
        <KnowMoreIcon $isOpen={this.state.isOpen}>
          <MsxIcons name="down-arrow"></MsxIcons>
        </KnowMoreIcon>
      </KnowMoreWrapper>}
    </DescriptionWrapper>;
  }
}

export default MultiLineText;
